<template>
  <div v-loading="fullscreenLoading">
    <div style="margin-left: 10.5%">
      <div style="padding-top: 20px"></div>
      <div
        class="Rectangle-5"
        v-bind:style="{ height: +(windowHeight - 200) + 'px' }"
      >
        <div style="padding: 3%; padding-top: 20px">
          <div style="display: inline-block; width: 70%"></div>

          <div style="display: inline-block; text-align: right; width: 30%">
            <div
              style="
                display: inline-block;
                text-align: right;
                max-width: 40%;
                margin-right: 10px;
              "
            >
              <el-button
                @click="onDialogBoolAddNewOpen()"
                style="color: #1bb24b; border-color: #1bb24b"
                >添加新优惠券</el-button
              >
            </div>
          </div>

          <div>
            <el-table
              :data="tableDataList"
              :height="windowHeight - 450"
              style="width: 100%"
              stripe
            >
              <el-table-column prop="title" label="内容名称"></el-table-column>
              <el-table-column label="适用类型">
                <template slot-scope="scope">
                  <div v-if="scope.row.type == 'all'">全部商品</div>
                  <div v-else>只允许特定分类</div>
                </template>
              </el-table-column>
              <el-table-column prop="price" label="金额"></el-table-column>

              <el-table-column fixed="right" label="操作" width="250">
                <template slot-scope="scope">
                  <el-button
                    type="text"
                    size="small"
                    @click="onDialogWithData(scope, 'send')"
                    >发放</el-button
                  >
                  <el-button
                    type="text"
                    size="small"
                    @click="onDialogWithData(scope, 'edit')"
                    >编辑</el-button
                  >
                  <el-button
                    type="text"
                    size="small"
                    @click="onDialogWithData(scope, 'delete')"
                    >删除</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div style="margin-top: 20px"></div>
        </div>
      </div>

      <el-dialog
        title="优惠券操作"
        :visible.sync="boolAddNew"
        width="80%"
        style="text-align: left"
        :before-close="onDialogBoolAddNewClose"
      >
        <div style="margin-top: 20px">
          <div style="display: inline-block; text-align: left; width: 30%">
            名称
          </div>
          <el-input
            style="display: inline-block; width: 70%"
            v-model="form.title"
          ></el-input>
        </div>

        <div style="margin-top: 20px">
          <div style="display: inline-block; text-align: left; width: 30%">
            适用类型
          </div>
          <el-select
            style="display: inline-block; width: 70%"
            v-model="form.type"
          >
            <el-option
              v-for="(item, index) in typeList"
              :key="index"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </div>

        <div style="margin-top: 20px">
          <div style="display: inline-block; text-align: left; width: 30%">
            过期时间
          </div>
          <el-date-picker
            v-model="form.expiredTime"
            value-format="yyyy-MM-dd"
            style="display: inline-block; width: 70%"
            type="date"
          ></el-date-picker>
        </div>

        <div style="margin-top: 20px">
          <div style="display: inline-block; text-align: left; width: 30%">
            金额
          </div>
          <el-input
            :min="0"
            type="number"
            style="display: inline-block; width: 70%"
            v-model="form.price"
          ></el-input>
        </div>

        <div style="margin-top: 20px" v-if="form.type == 'banCategories'">
          <div style="display: inline-block; text-align: left; width: 30%">
            商品分类
          </div>
          <el-cascader
            style="width: 70%"
            v-model="form.banCategories"
            :options="megaCategoriesList"
            :props="cateProps"
            clearable
          ></el-cascader>
        </div>

        <div style="text-align: right; margin-top: 20px">
          <el-button
            v-if="!boolEdit"
            @click="onAddNewConfirm()"
            style="
              display: inline-block;
              margin-left: 20px;
              background-color: #1bb24b;
              width: 125px;
            "
            type="success"
            >确认</el-button
          >
          <el-button
            v-if="boolEdit"
            @click="onEditConfirm()"
            style="
              display: inline-block;
              margin-left: 20px;
              background-color: #1bb24b;
              width: 125px;
            "
            type="success"
            >确认</el-button
          >
          <el-button
            @click="onDialogBoolAddNewClose()"
            style="color: #1bb24b; border-color: #1bb24b; width: 125px"
            >取消</el-button
          >
        </div>
      </el-dialog>

      <el-dialog
        title="删除操作"
        :visible.sync="boolDelete"
        width="50%"
        style="text-align: left"
        :before-close="onDialogBoolDeleteOpen"
      >
        <div style="text-align: right; margin-top: 20px">
          <el-button
            @click="onDeleteConfirm()"
            style="
              display: inline-block;
              margin-left: 20px;
              background-color: #1bb24b;
              width: 125px;
            "
            type="success"
            >确认</el-button
          >
          <el-button
            @click="onDialogBoolDeleteOpen()"
            style="color: #1bb24b; border-color: #1bb24b; width: 125px"
            >取消</el-button
          >
        </div>
      </el-dialog>

      <el-dialog
        title="发放操作"
        :visible.sync="boolSend"
        width="50%"
        style="text-align: left"
        :before-close="onDialogBoolSendOpen"
      >
        <div>
          <div style="display: inline-block; text-align: left; width: 30%">
            用户
          </div>
          <el-select
            v-model="formUser.belongUserIds"
            multiple
            filterable
            remote
            reserve-keyword
            placeholder="请输入用户名称"
            :remote-method="onFetchUser"
            :loading="boolLoading"
          >
            <el-option
              v-for="item in userList"
              :key="item.id"
              :label="item.username"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </div>

        <div style="text-align: right; margin-top: 20px">
          <el-button
            @click="onSendConfirm()"
            style="
              display: inline-block;
              margin-left: 20px;
              background-color: #1bb24b;
              width: 125px;
            "
            type="success"
            >确认</el-button
          >
          <el-button
            @click="onDialogBoolSendClose()"
            style="color: #1bb24b; border-color: #1bb24b; width: 125px"
            >取消</el-button
          >
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
export default {
  name: "adModify",
  data() {
    return {
      fullscreenLoading: false,
      windowWidth: window.innerWidth,
      windowHeight: window.innerHeight,

      searchKeyword: "",

      currentData: {},
      currentPage: 1,

      tableDataList: [],
      tableDataTotal: 0,
      boolAddNew: false,
      boolEdit: false,
      boolDelete: false,

      boolLoading: false,
      boolSend: false,

      form: {
        expiredTime: null,
        title: "",
        type: "all",
        price: 0,
        banCategories: null,
      },

      megaCategoriesList: [],
      cateProps: { multiple: true },

      formUser: {
        belongUserIds: [],
      },

      typeList: [
        { label: "全部商品", value: "all" },
        { label: "只允许特定分类", value: "banCategories" },
      ],

      userList: [],
    };
  },
  mounted() {},
  created() {
    this.onCheckloginRole();
    this.onFetchTableData();
    this.onFetchProductMegaCategoriesData();
  },
  methods: {
    // check if  login
    onCheckloginRole() {
      // var temp = localStorage.getItem("auth");
      // if (temp == undefined || temp != "b60afdc1f3657130c165d32743603a59") {
      //   this.$router.push("/login");
      // }
      var temp = localStorage.getItem("auth");
      this.axios
        .post(this.$urlGlobal + "adminCheck", {
          auth: temp,
        })
        .then((res) => {
          if (res.data.code == -1) {
            this.$router.push("/login");
            localStorage.removeItem("auth");
            window.location.reload();
          }
        });
    },

    // search  table by name
    onSearchTableData() {
      // init the page and fetch data
      this.currentPage = 1;
      this.onFetchTableData();
    },
    // fetch table data also with condition
    onFetchTableData() {
      this.fullscreenLoading = true;
      this.axios
        .post(this.$urlGlobal + "adminFetchCouponByPage", {})
        .then((res) => {
          this.fullscreenLoading = false;
          this.tableDataList = res.data.data.data;
        });
    },

    // add new  operation
    onDialogBoolAddNewOpen() {
      this.boolAddNew = true;
    },
    onDialogBoolAddNewClose() {
      this.boolAddNew = false;
      // also close edit because they use same form
      this.boolEdit = false;
      this.form = {
        expiredTime: null,
        title: "",
        type: "all",
        price: 0,
        banCategories: null,
      };
    },

    onAddNewConfirm() {
      if (
        this.form.type == "" ||
        this.form.title == "" ||
        this.form.price == ""
      ) {
        this.$message({
          message: "尚有未填信息",
          type: "warning",
        });
        return;
      }
      this.fullscreenLoading = true;
      this.axios
        .post(this.$urlGlobal + "adminInsertCoupon", {
          type: this.form.type,
          title: this.form.title,
          price: this.form.price,
          expiredTime: this.form.expiredTime,
          banCategories: this.form.banCategories,
        })
        .then((res) => {
          this.fullscreenLoading = false;
          if (res.data.code == 1) {
            this.$message({
              message: "操作失败",
              type: "warning",
            });
          } else {
            this.$message({
              message: "操作成功",
              type: "success",
            });
          }
          this.onDialogBoolAddNewClose();
          this.onFetchTableData();
        });
    },

    // edit  operation
    onDialogBoolEditOpen() {
      this.boolAddNew = true;
      this.boolEdit = true;
      this.form = {
        expiredTime: this.currentData.expiredTime,
        title: this.currentData.title,
        type: this.currentData.type,
        price: this.currentData.price,
        banCategories: this.currentData.banCategories,
      };
    },
    onEditConfirm() {
      if (
        this.form.type == "" ||
        this.form.title == "" ||
        this.form.price == ""
      ) {
        this.$message({
          message: "尚有未填信息",
          type: "warning",
        });
        return;
      }
      this.fullscreenLoading = true;
      this.axios
        .post(this.$urlGlobal + "adminUpdateCoupon", {
          id: this.currentData.id,
          type: this.form.type,
          title: this.form.title,
          expiredTime: this.form.expiredTime,
          price: this.form.price,
          banCategories: this.form.banCategories,
        })
        .then((res) => {
          this.fullscreenLoading = false;
          if (res.data.code == 1) {
            this.$message({
              message: "修改失败",
              type: "warning",
            });
            return;
          } else {
            this.$message({
              message: "修改成功",
              type: "success",
            });
          }
          this.onDialogBoolAddNewClose();
          this.onFetchTableData();
        });
    },

    // delete  operation
    onDialogBoolDeleteOpen() {
      this.boolDelete = true;
    },
    onDialogBoolDeleteClose() {
      this.boolDelete = false;
    },
    onDeleteConfirm() {
      this.fullscreenLoading = true;
      this.axios
        .post(this.$urlGlobal + "adminUpdateCoupon", {
          id: this.currentData.id,
          status: "off",
        })
        .then((res) => {
          this.fullscreenLoading = false;
          this.$message({
            message: "删除成功",
            type: "success",
          });
          this.onDialogBoolDeleteClose();
          this.onFetchTableData();
        });
    },

    // send operation
    onDialogBoolSendOpen() {
      this.boolSend = true;
    },
    onDialogBoolSendClose() {
      this.boolSend = false;
    },
    onSendConfirm() {
      this.fullscreenLoading = true;
      this.axios
        .post(this.$urlGlobal + "adminSendCoupon", {
          id: this.currentData.id,
          belongUserIds: this.formUser.belongUserIds,
        })
        .then((res) => {
          this.fullscreenLoading = false;
          this.$message({
            message: "发放成功",
            type: "success",
          });
          this.onDialogBoolSendClose();
        });
    },

    onFetchUser(query) {
      this.boolLoading = true;
      this.axios
        .post(this.$urlGlobal + "adminFetchUserAll", {
          keyword: query,
        })
        .then((res) => {
          this.boolLoading = false;
          this.userList = res.data.data;
        });
    },

    // mega categories
    onFetchProductMegaCategoriesData() {
      this.fullscreenLoading = true;
      this.axios
        .post(this.$urlGlobal + "adminFetchMegaCategories", {})
        .then((res) => {
          this.megaCategoriesList = res.data.data;
          this.fullscreenLoading = false;
        });
    },

    // table operation
    onDialogWithData(scope, e) {
      this.currentData = scope.row;
      switch (e) {
        case "send":
          this.onDialogBoolSendOpen();
          break;
        case "edit":
          this.onDialogBoolEditOpen();
          break;
        case "delete":
          this.onDialogBoolDeleteOpen();
          break;
      }
    },
  },
};
</script>

